import PropTypes from "prop-types";
import React, { useContext } from "react";
import { createUseStyles } from "react-jss";
import {
  TranslationContext,
  CurrencyContext,
  StyleTypeContext,
} from "../../umbilical_tools";
import _ from "lodash";
import { getCurrency } from "./helpers";
import { Icon, InlineIcon } from "@iconify/react";
import jssVariables from "../../jss_setup";
import { useSelector } from "react-redux";

const styles = createUseStyles({
  currencyModal: (props) => ({
    display: "grid",
    gridTemplateRows: "auto 1fr",
    position: "fixed",
    background: "rgba(0,0,0, 0.6)",
    left: "0px",
    top: "0px",
    width: "100vw",
    height: "100%",
    zIndex: 9999,
    alignItems: "center",
    ..._.get(props, "customStyles.currencyModal", {}),
  }),
  mainPanel: (props) => ({
    display: "grid",
    alignItems: "baseline",
    gridTemplateRows: "max-content 1fr",
    background: jssVariables.colors.background.light,
    height: "100vh",
    padding: `calc(${jssVariables.normal_gap} * 2)`,
    ..._.get(props, "customStyles.mainPanel", {}),
  }),
  headerPanel: (props) => ({
    top: 0,
    display: "grid",
    gridTemplateColumns: "1fr max-content",
    alignItems: "center",
    ..._.get(props, "customStyles.headerPanel", {}),
  }),
  header: (props) => ({
    fontStyle: "normal",
    fontSize: "x-large",
    fontWeight: "bold",
    color: jssVariables.colors.text.dark,
    ..._.get(props, "customStyles.header", {}),
  }),
  closeIconSpan: (props) => ({
    ..._.get(props, "customStyles.closeIconSpan", {}),
  }),
  closeIcon: (props) => ({
    fontSize: "xxx-large",
    cursor: "pointer",
    color: jssVariables.colors.text.dark,
    ..._.get(props, "customStyles.closeIcon", {}),
  }),
  linksPanel: (props) => ({
    marginTop: `calc(${jssVariables.normal_gap} * 4)`,
    display: "grid",
    justifyItems: "center",
    color: jssVariables.colors.base_colorType4,
    gridTemplateColumns: "repeat(3, 1fr)",
    padding: `calc(${jssVariables.normal_gap} * 1) calc(${jssVariables.normal_gap} * 3)`,
    gridGap: `calc(${jssVariables.normal_gap} * 1)`,
    ..._.get(props, "customStyles.linksPanel", {}),
  }),
  link: (props) => ({
    fontSize: "large",
    alignItems: "start",
    padding: `calc(${jssVariables.normal_gap} * 1) 0`,
    cursor: "pointer",
    display: "grid",
    gridGap: `calc(${jssVariables.normal_gap} * .5)`,
    alignContent: "center",
    gridTemplateColumns: "max-content max-content",
    color: jssVariables.colors.text.dark,
    ..._.get(props, "customStyles.link", {}),
  }),
  icon: (props) => ({
    fontSize: "x-large",
    overflow: "hidden",
    ..._.get(props, "customStyles.icon", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    currencyModal: (props) => ({
      display: props.showModal ? "grid" : "none",
      gridTemplateRows: "auto 1fr",
      padding: "10vh 30vw",
      ..._.get(props, "customStyles.currencyModal.smallscreen", {}),
    }),
    mainPanel: (props) => ({
      height: "max-content",
      ..._.get(props, "customStyles.mainPanel.smallscreen", {}),
    }),
    closeIconSpan: (props) => ({
      ..._.get(props, "customStyles.closeIconSpan.smallscreen", {}),
    }),
    linksPanel: (props) => ({
      marginTop: `calc(${jssVariables.normal_gap} * 4)`,
      gridAutoRows: "max-content",
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)",
      justifyItems: "center",
      padding: `calc(${jssVariables.normal_gap} * 2)`,
      ..._.get(props, "customStyles.linksPanel.smallscreen", {}),
    }),
  },
});
const CurrencySelectorModal = (props) => {
  const { showModal, closeCurrencyModal } = props;
  const { t } = useContext(TranslationContext);
  const { changeCurrency } = useContext(CurrencyContext);
  const { type, brand, cStyler } = useContext(StyleTypeContext);

  const classes = styles({
    showModal,
    customStyles: cStyler({ type, brand, objName: "currencyModal" }),
  });

  const currencies = useSelector((state) =>
    _.get(state, "WebsiteMetadata.metadata.currencies", [])
  );

  function handleCurrency(input) {
    changeCurrency(input);
    closeModal();
  }

  function closeModal() {
    closeCurrencyModal(false);
  }

  return (
    <React.Fragment>
      <div className={classes.currencyModal}>
        <div className={classes.mainPanel}>
          <div className={classes.headerPanel}>
            <span className={classes.header}>{t("selectCurrency")}</span>
            <span onClick={closeModal} className={classes.closeIconSpan}>
              <Icon
                icon="material-symbols:close"
                className={classes.closeIcon}
              />
            </span>
          </div>
          <div className={classes.linksPanel}>
            {currencies.map((curr, idx) => (
              <div
                className={classes.link}
                onClick={() => handleCurrency(curr)}
                key={idx}>
                <InlineIcon icon={getCurrency(curr)} className={classes.icon} />{" "}
                <span className={classes.label}>{curr}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
CurrencySelectorModal.defaultProps = {
  showModal: false,
};
CurrencySelectorModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  closeCurrencyModal: PropTypes.func.isRequired,
};

export default CurrencySelectorModal;
